/*
 * @Author: chenliang
 * @Date: 2021-02-02 14:51:11
 * @LastEditors: chenliang
 * @LastEditTime: 2021-02-05 13:54:27
 * @Description: 统计
 */
import React, { Component } from 'react';
import {Row,Col} from 'antd'
import LmmCard from './LmmCard'

export default class CountCard extends Component {
  static propTypes = {

  };

  render() {
      const {
        companyAll,
        companyToday,
        positionAll,
        positionToday,
        userAll,
        userToday,
        onTabChange,
        tabValue,
      } = this.props;
      console.log(tabValue)
    return (
      <div className="home-count-card">
          <Row>
            <Col span={8} style={{paddingRight: '24px'}}>   
                <LmmCard fouce = {tabValue == 1 ? 1 : 0} onClick={() => {onTabChange(1)}} title="企业总数量" subtitle ={`今日新增企业:${companyToday}`}>
                    <div style={{fontSize:'30px',margin:'10px 0px 10px 0px'}}>{companyAll}</div>
                </LmmCard>
            </Col>
            <Col span={8} style={{paddingRight: '24px'}}>   
                <LmmCard fouce = {tabValue == 2 ? 1 : 0} onClick={() => {onTabChange(2)}} title="人员总数量" subtitle ={`今日新增求职者:${userToday}`}>
                    <div style={{fontSize:'30px',margin:'10px 0px 10px 0px'}}>{userAll}</div>
                </LmmCard>
            </Col>
            <Col span={8}>   
                <LmmCard fouce = {tabValue == 3 ? 1 : 0}  onClick={() => {onTabChange(3)}} title="职位总数量" subtitle ={`今日新增职位:${positionToday}`}>
                    <div style={{fontSize:'30px',margin:'10px 0px 10px 0px'}}>{positionAll}</div>
                </LmmCard>
            </Col>
          </Row>
       
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/CountCard.js